export default {"src":"/_next/static/media/microchip_40.c09a4cd3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};